import Modal from 'components/Modal'
import BankAccounts from 'views/MerchantProfile/ManualTx/BankAccounts/Form'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalMembership = ({ title, open, onClose }: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <BankAccounts onCloseModal={onClose} />
    </Modal>
  )
}

export default ModalMembership
